module.exports = __webpack_public_path__ + "img/1440.69e5760c.jpg";